import { observer } from "mobx-react-lite";
import { store } from "../stores/Store";
import { publicUrl } from "../utils/url";
import { _t } from "../utils/Lang";
import './CartMattressBanner.scss';

/**
 * MYB-144: promotional banner shown inside the cart-summary modal, promoting the
 * 10% mattress-in-a-set discount. The CTA closes the modal and jumps to the
 * configurator's "mattress" step.
 *
 * Desktop: three columns — title | image | button.
 * Mobile: stacked — title, button, image.
 */
const CartMattressBanner = observer(({
    imageDesktop = publicUrl('/assets/banner-cart-desktop.png'),
    imageMobile = publicUrl('/assets/banner-cart-mobile.png'),
}) => {
    // MYB-144: nothing to promote once a mattress is already in the set.
    if (store.selectedMattress.length > 0) {
        return null;
    }

    const goToMattresses = () => {
        const step = store.getStepByType('mattress');
        store.closeCartSummaryPopup();
        // Let the modal close before scrolling the configurator.
        requestAnimationFrame(() => {
            if (step) {
                store.scrollTo(step.typeId);
            }
        });
    };

    return (
        <div className="CartMattressBanner">
            <p className="CartMattressBanner__title">
                <em>{_t('mattress_banner_title_em')}</em>{' '}
                {_t('mattress_banner_title')}{' '}
                <span className="CartMattressBanner__accent">{_t('mattress_banner_accent')}</span>
            </p>

            <img
                className="CartMattressBanner__image CartMattressBanner__image--mobile"
                src={imageMobile}
                alt=""
            />
            <img
                className="CartMattressBanner__image CartMattressBanner__image--desktop"
                src={imageDesktop}
                alt=""
            />

            <div className="CartMattressBanner__actions">
                <button
                    type="button"
                    className="CartMattressBanner__cta"
                    onClick={goToMattresses}
                >
                    {_t('mattress_banner_cta')}
                </button>
            </div>
        </div>
    );
});
CartMattressBanner.displayName = 'CartMattressBanner';
export default CartMattressBanner;
